import { NoteAdd } from "@mui/icons-material";
import { ResponsiveButton } from "components/Button";
import { EntitySelector } from "modals/EntitySelector";
import { FC, useState } from "react";
import { Requirement } from "types/requirement";
import { getFilteredList } from "utils/Array";

type AddRequirementSelectorProps = {
  requirements: Requirement[];
  onSelect: (requirement: Requirement) => void;
  selectedRequirement: Requirement[];
};

export const AddRequirementSelector: FC<AddRequirementSelectorProps> = ({
  requirements,
  onSelect,
  selectedRequirement,
}) => {
  const [open, setOpen] = useState(false);

  if (!requirements || !selectedRequirement) {
    return null;
  }

  return (
    <>
      <ResponsiveButton
        onClick={() => {
          setOpen(true);
        }}
        icon={<NoteAdd />}
        variant="outlined"
      >
        Select
      </ResponsiveButton>
      <EntitySelector
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        title="Add a requirement"
        listEntities={getFilteredList(
          requirements,
          selectedRequirement,
          "requirement_id",
        )}
        filterCriteria={(text, data) => {
          return data.name.toLowerCase().includes(text.toLowerCase());
        }}
        keyField="requirement_id"
        displayField="name"
        onSelect={onSelect}
      />
    </>
  );
};
